import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Zone, Role } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  role: Identifiable<Role>;
  retrieveZoneRole(request: Boundaries["retrieveZoneRole"]["request"]): void;
}

function useRetrieveZoneRole(zone: Identifiable<Zone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveZoneRoleRequestPending(zone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveZoneRoleRequestSuccess(zone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveZoneRoleRequestFailure(zone),
    ),
    role: useSelector(() => selector.getZoneRole(zone)),
    retrieveZoneRole: core.retrieveZoneRole,
  };
}

export { useRetrieveZoneRole };
